export default [function () {
    // this service is intended to return a vehicle picture given year, make, and model
    // this implementation is hard coded to two vehicles for demo purpose only
    // consult documentation for a sample implementation using third party photo lookup
    return {
        lookupPhoto: function lookupPhoto(dto) {
            var year = dto.year,
                make = dto.make,
                model = dto.model;

            var mo = model.toUpperCase();
            var mk = make.toUpperCase();
            var imageURL = '';
            if (mk === 'TOYOTA' && mo === 'AVENSIS' && year) {
                imageURL = '../styles/images/common/stockphotos/toyota_avensis.jpg';
            } else if (mk === 'AUDI' && mo === 'A4' && year) {
                imageURL = '../styles/images/common/stockphotos/audi_a4.jpg';
            }
            return Promise.resolve(imageURL);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policyjob/services/VehicleImageLookupService.js
// module id = 1198
// module chunks = 0